// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
import React from 'react'
import { TaskStatus } from 'constants/job'
import { Tag } from 'antd'

export interface ITaskStatusCellProps {
  status: TaskStatus
}
export function TaskStatusCell (props: ITaskStatusCellProps) {
  let text = ''
  let color = ''
  switch (props.status) {
    case TaskStatus.Pending:
      color = 'blue'
      text = 'Pending'
      break
    case TaskStatus.Uploading:
      color = 'cyan'
      text = 'UploadingFromKC'
      break
    case TaskStatus.Stitching:
      color = 'cyan'
      text = 'Stitching'
      break
    case TaskStatus.UploadingKV:
      color = 'cyan'
      text = 'UploadingToKV'
      break
    case TaskStatus.Successful:
      color = 'green'
      text = 'Completed'
      break
    // case TaskStatus.Failed:
    //   color = 'red'
    //   text = 'Failed'
    //   break
    // case TaskStatus.Due:
    //   color = 'purple'
    //   text = 'Due'
    //   break
    // case TaskStatus.Disabled:
    //   text = 'Disabled'
    //   break
    case TaskStatus.Paused:
      color = 'orange'
      text = 'Paused'
      break
    case TaskStatus.Stopped:
      color = 'orange'
      text = 'Stopped'
      break
    case TaskStatus.WaitForStitching:
      color = 'cyan'
      text = 'WaitForStitching'
      break
    case TaskStatus.Stitched:
      color = 'green'
      text = 'Stitched'
      break
    default:
      break
  }
  return <Tag color={color}>{text}</Tag>
}
